import { Component, effect, inject, Input, signal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatIcon } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LAYERS_ORDER, URL_LEGEND } from '@core/constants/constant.data'
import { LayerStandard } from '@core/models/layers.model'
import { LayersService } from '@core/services/layers.service'
import { SelectionToolService } from '@core/services/selection-tool.service'

@Component({
  selector: 'app-card-layer-standard',
  templateUrl: 'card-layer-standard.component.html',
  imports: [
    // Material
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatIcon,
    MatButtonModule,
  ],
})
export class CardLayerStandardComponent {
  @Input({ required: true }) layer!: LayerStandard
  private readonly _layersService = inject(LayersService)
  private readonly _selectionToolService = inject(SelectionToolService)
  imageUrl = URL_LEGEND
  isLoading$ = signal<boolean>(false)
  allowDownload$ = signal<boolean>(false)

  constructor() {
    effect(() => {
      this._updateButtonDownloadStatus()
    })
  }

  showRemoveLayer() {
    this._layersService.showOrRemoveLayerWithBoolean(
      this.layer.workspacename,
      this.layer.order || LAYERS_ORDER,
      !this.layer.isSelected,
    )
  }

  async exportLayerSelection() {
    this.isLoading$.set(true)
    const response = await this._selectionToolService.exportLayerSelection(this.layer)

    if (response) {
      const url = URL.createObjectURL(response) as string
      const filename =
        this.layer.workspacename +
        `.${this.layer.dataType == 'raster' ? 'tif' : this.layer.dataType}`
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }
    this.isLoading$.set(false)
  }

  private _updateButtonDownloadStatus(): void {
    this.allowDownload$.set(this._selectionToolService.isLayerSelectionDownloadSurfaceCorrect())
  }

  isLayerLoading(): boolean {
    return this._layersService.layersLoading$()[this.layer.workspacename] ?? false
  }
}
